import React from 'react';
import NumberFormat from 'react-number-format';
import { Table } from 'semantic-ui-react';
import OrderDeliveryComponent from './order.delivery';
import OrderModel from './order.model';

type OrderContentsProps = {
  order: Pick<OrderModel, 'deliveries' | 'totalAmount' | 'totalDeliveryCost'>
};

/**
 * Захиалгын бараа ба дүн. Дэлгэрэнгүй хуудасны баримт зөвхөн CONFIRMED захиалгад гардаг тул
 * төлөгдөөгүй (PLACED) болон цуцлагдсан (ARCHIVED) захиалгын агуулгыг үүгээр харуулна.
 */
function OrderContentsComponent({ order }: OrderContentsProps) {
  return (
    <div className="order-contents width-100" data-testid="order-contents">
      <h2>Захиалгын бараа</h2>
      <Table striped className="admin-list-table" width={16}>
        <Table.Body>
          {(order.deliveries || []).map((delivery: any) =>
            <OrderDeliveryComponent key={`order-contents-${delivery.id}`} delivery={delivery} colSpan={1} />
          )}
        </Table.Body>
      </Table>
      <div className="order-summary">
        <div>Барааны нийт үнэ: <NumberFormat displayType="text" value={order.totalAmount - order.totalDeliveryCost} suffix="₮" thousandSeparator={true} /></div>
        <div>Хүргэлтийн нийт үнэ: <NumberFormat displayType="text" value={order.totalDeliveryCost || 0} suffix="₮" thousandSeparator={true} /></div>
        <div>Нийт үнэ: <NumberFormat displayType="text" value={order.totalAmount || 0} suffix="₮" thousandSeparator={true} /></div>
      </div>
    </div>
  );
}

export default OrderContentsComponent;
